module.exports = __webpack_public_path__ + "static/img/iconmenu01_white.243d1873.svg";